import '@/instrument';
import * as React from 'react';
import { createRoot } from 'react-dom/client';

import '@/index.css';
import { App } from '@/app/app';

import '@/lib/firebase';
import '@/lib/i18next/config';

const root = document.getElementById('root');
if (!root) throw new Error('No root element found');

createRoot(root).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
